import { clsx } from 'clsx';

import {
  AlertCircleFilled,
  Checkmark
} from '@teachstonellc/component-library/dist/icons';

const variants = {
  circle: 'w-5 h-5 sm:w-6 sm:h-6',
  pill: 'w-12 h-5 sm:w-14 sm:h-6'
};

interface StatusIndicatorProps {
  /** If `true`, the circle will be green. */
  completed: boolean;

  /** If `true` (and `completed` is `false`), an error icon is shown. */
  hasError?: boolean;

  /** Variant of the indicator. */
  variant?: keyof typeof variants;

  /** Element to render. */
  children?: React.ReactNode;
}

export function StatusIndicator({
  completed,
  hasError = false,
  children,
  variant = 'circle'
}: StatusIndicatorProps) {
  const classes = clsx(
    'rounded-full shadow-md font-bold text-xs inline-flex items-center justify-center ml-2',
    // 640px and up
    'sm:text-base sm:ml-3',
    // base state
    'bg-ds-white text-ds-white',
    // completed state
    'data-[completed=true]:bg-scale-green',
    // variant styles,
    variants[variant] || variants.circle
  );

  if (hasError && !completed) {
    return (
      <div className={classes} data-completed={false}>
        <AlertCircleFilled className="text-scale-red" />
      </div>
    );
  }

  return (
    <div className={classes} data-completed={completed}>
      {children || <Checkmark size={16} />}
    </div>
  );
}
